/**
 * @param {string} cname
 * @param {*} cvalue
 * @param {number} exdays
 * @param {?string} [domain]
 */
const setCookie = (cname, cvalue, exdays, domain) => {
  if (typeof window !== 'undefined') {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    if (domain) {
      document.cookie = `${cname}=${cvalue};${expires};path=/;domain=${domain}`;
    } else {
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    }
  }
};

export default setCookie;
